module.exports = __webpack_public_path__ + "img/drinks-1.20f40257.jpg";